import {
  Button,
  CloseButton,
  Dialog,
  Form,
  Modal,
  ModalOverlay,
} from "@light-technology/components";
import { type ReactNode } from "react";

type FormModalProps = {
  textTitle: string;
  textCancel: string;
  textSubmit: string;
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  children: ReactNode | ReactNode[];
  isDisabled?: boolean;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  "data-ph-capture-attribute-action"?: string;
};

export const FormModal = (props: FormModalProps) => {
  return (
    <ModalOverlay
      isDismissable
      isOpen={props.isOpen}
      onOpenChange={props.onOpenChange}
    >
      <Modal>
        <Dialog aria-label={props.textTitle}>
          <div className="relative w-full max-w-100 rounded-2xl bg-primary p-3xl">
            <CloseButton
              className="absolute top-4 right-2 z-0"
              size="lg"
              onClick={props.onCancel}
            />
            <Form validationBehavior="aria" onSubmit={props.onSubmit}>
              <div className="pointer-events-none relative pr-4xl pb-2xl text-lg font-semibold">
                {props.textTitle}
              </div>
              {props.children}
              <div className="flex gap-lg pt-4xl">
                <Button
                  className="flex-1"
                  color="secondary"
                  size="lg"
                  onClick={props.onCancel}
                >
                  {props.textCancel}
                </Button>
                <Button
                  className="flex-1"
                  type="submit"
                  size="lg"
                  isDisabled={props.isDisabled ?? false}
                  isLoading={props.isLoading}
                  data-ph-capture-attribute-action={
                    props["data-ph-capture-attribute-action"]
                  }
                >
                  {props.textSubmit}
                </Button>
              </div>
            </Form>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};
